import axios from 'axios';

// Use relative path in production/staging so requests go through CloudFront
// Use localhost for local development
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api'  // Relative path for CloudFront routing
  : process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000, // 10 second timeout to handle Lambda cold starts
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors — prevent multiple redirects from parallel requests
let isRedirecting = false;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isRedirecting) {
      isRedirecting = true;
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);